import * as sum from 'lodash/sum';

import { FactOperator } from './fact-operator';

export class SubtractionOperator implements FactOperator {
	public calculate(values: number[]): number {
		const minuend = values.shift();
		return minuend - sum(values);
	}
}
